import { render, staticRenderFns } from "./RatingCard.vue?vue&type=template&id=3ad0c5e9&scoped=true&"
import script from "./RatingCard.vue?vue&type=script&lang=js&"
export * from "./RatingCard.vue?vue&type=script&lang=js&"
import style0 from "./RatingCard.vue?vue&type=style&index=0&id=3ad0c5e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad0c5e9",
  null
  
)

export default component.exports